import { PartState } from '../types';
import { curiousState } from './curious';
import { excitedState } from './excited';

/**
 * Buzzing state — Bizy energetically working with both arms raised mid-level,
 * wide eyes, and spread wings. Used during the streaming/response phase.
 * Stars add a sparkly "processing" feel.
 */
export const buzzingState: PartState = {
	antenna1: excitedState.antenna1,
	antenna2: excitedState.antenna2,
	body: curiousState.body,
	bodyHighlight: curiousState.bodyHighlight,
	stripes: curiousState.stripes,
	stinger: curiousState.stinger,
	badge: curiousState.badge,
	// Wide wing spread — actively flying
	wing1Path: excitedState.wing1Path,
	wing2Path: excitedState.wing2Path,
	wing3Path: excitedState.wing3Path,
	wing4Path: excitedState.wing4Path,
	// Wide excited eyes
	eyes: excitedState.eyes,
	// Arms at mid-level — between curious (down) and excited (high up)
	arms: [
		{ d: 'M107.22 144L102 131C101.3 125 100.5 119 99.6 114L91 104', side: 'left' },
		{ d: 'M201.62 144L208 131C208.7 125 209.5 119 210.4 114L219 104', side: 'right' },
	],
	// Sparkle stars for active-processing energy
	stars: excitedState.stars,
};
